import { render, staticRenderFns } from "./PrincipalV.vue?vue&type=template&id=0165a954"
import script from "./PrincipalV.vue?vue&type=script&lang=js"
export * from "./PrincipalV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports